import React from 'react'
import SmallLoader from './SmallLoader'
const NoDetail = (props) => {
  return (
    <div className='Nodata'>
        {props.loading?<SmallLoader/>:
        <>
        <img src={require('../Assets/Icons/Nothing_found.png')} alt="" />
        <span>No results found</span> 
        </>}
    </div>
  )
}

export default NoDetail